
function validateApiResponse(data) {
    // we expect the api to respond with a json object with at least the following keys:
    // {
    //     "e_single": 2000,
    //     "e_high": 500,
    //     "e_low": 500,
    //     "gas": 900
    // }
    // if the response is not valid, we return false
    // if the response is valid, we return true
    if (data.e_single && data.e_high && data.e_low && data.gas) {
        return true;
    }
    return false;
}



export default async function FetchVerbruikEstimate({
    householdSize,
    selectedBuildingType,
    entity,
    setIsFetchingData,
    agentID
  }) {


    const BACKEND_URL = process.env.BACKEND_URL + "/index?m=estimate"

    const entity_is_business = entity === "Particulier" ? 0 : 1;

    const persons = householdSize >= 5 ? "5-6" : householdSize >= 3 ? "3-4" : householdSize.toString();



    const url = new URL(BACKEND_URL);
    const params = { m: "estimate", building_type: selectedBuildingType, business: entity_is_business, agent: agentID };
    // add household_size: persons to params if entity is not business
    if (!entity_is_business) {
        params.household_size = persons;
    }
    url.search = new URLSearchParams(params).toString();
    setIsFetchingData(true);
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    try {
        if (response.ok) {
            const data = await response.json();
            if (!validateApiResponse(data)) {
                console.error('Error fetching usage estimate: invalid response', response);
                setIsFetchingData(false);
                return false;
            }
            setIsFetchingData(false);
            return data;
        } else {
            console.error('Error getting usage estimate', response);
            setIsFetchingData(false);
            return;
        }
    } catch (error) {
        console.error('Error getting usage estimate', error);
        setIsFetchingData(false);
        return;
    }


}

